var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container"},_vm._l((_vm.buttonNumbers),function(number){return _c('button',{key:number.val,staticClass:"button",on:{"click":function($event){return _vm.goTo(number.val)}}},[_vm._v(" Línea "+_vm._s(number.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }